import styles from "./components.module.scss";
import clsx from "clsx";
import React from "react";
import {ContainedButton, OutlinedButton, Description} from "../AvailableJob.styles";
import Popup from "components/Popup";
import { StyledButton } from "components/Buttons/DefaultButton/DefaultButton.styles";

// @ts-ignore
const TempStars = window.TempStars

interface MaxBookedPopupProps {
    isOpen: boolean;
    onClose: () => void;
    canRequestIncrease: boolean;
  }

const MaxBookedPopup: React.FC<MaxBookedPopupProps> = ({ isOpen, onClose, canRequestIncrease }) => {
    const helpEmail = TempStars.Config[TempStars.Hygienist.getCountry()].helpEmail;
    
    const handleRequestIncrease = () => {
      window.open(`mailto:${helpEmail}?subject=Request for Maximum Booking Increase`);
    };
  
    const handleLearnMore = () => {
      window.open('https://support.tempstars.com/hc/en-us/articles/360047221113-Maximum-Booking-Limits-and-your-status', '_blank');
    };
  
    if (!isOpen) return null;
  
    return (
      <Popup opened={isOpen} onClose={onClose}>
        <div className={styles.popupContainer}>
          <h2 className={styles.popupTitle}>Maximum Bookings Reached</h2>
          <p className={styles.modalDescription}>
            As you successfully complete shifts, your maximum will increase. Positive reviews also increase your maximum.
          </p>
          <p className={styles.modalDescription}>
            Hint: Submit offers for shifts starting soon to increase your maximum more quickly.
          </p>
          <a href="https://support.tempstars.com/hc/en-us/articles/360047221113-Maximum-Booking-Limits-and-your-status" className={clsx("external", styles.popupLink)} target="_system" onClick={handleLearnMore}>Learn about Maximum Bookings</a>
          <StyledButton
            className={styles.modalButton}
            variant="contained"
            size="large"
            onClick={onClose}
          >
            Close
          </StyledButton>
          {canRequestIncrease && (
            <StyledButton
              className={styles.modalButton}
              variant="outlined"
              size="large"
              onClick={handleRequestIncrease}
            >
              Request an Increase
            </StyledButton>
          )}
        </div>
      </Popup>
    );
  };

  export default MaxBookedPopup;
